/* ===========================================================
   Totem Review — il poco codice che serve alla pagina.
   Tre cose: la barra in alto che si attacca, le sezioni che
   compaiono salendo, e le due animazioni che seguono lo scorrere.
   Tutto si rifa' i conti quando il pannello di Shopify ricarica
   una sezione, cosi' si vede subito anche dentro Personalizza.
   =========================================================== */
(function () {
  'use strict';

  /* ---- 1. la barra in alto ---- */
  function barra() {
    var t = document.getElementById('testata');
    if (!t || t._gia) return;
    t._gia = true;
    function scorri() { t.classList.toggle('attaccata', window.scrollY > 40); }
    window.addEventListener('scroll', scorri, { passive: true });
    scorri();

    /* il pannello delle voci, da telefono */
    var bottone = t.querySelector('.apri-menu');
    var pannello = t.querySelector('.menu-tel');
    if (!bottone || !pannello) return;

    function mostra(si) {
      t.classList.toggle('aperta', si);
      bottone.setAttribute('aria-expanded', si ? 'true' : 'false');
      if (si) { pannello.removeAttribute('hidden'); }
      else { pannello.setAttribute('hidden', ''); }
    }
    mostra(false);

    bottone.addEventListener('click', function () {
      mostra(!t.classList.contains('aperta'));
    });
    /* toccata una voce, il pannello si richiude da solo */
    pannello.addEventListener('click', function (e) {
      if (e.target.closest('a')) mostra(false);
    });
    /* via col tasto Esc, e via anche se la finestra torna larga */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') mostra(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) mostra(false);
    });
  }

  /* ---- 2. le sezioni che compaiono ---- */
  var occhio = null;
  function comparsa(dove) {
    var pezzi = [].slice.call((dove || document).querySelectorAll('.su'));
    if (!('IntersectionObserver' in window)) {
      pezzi.forEach(function (e) { e.classList.add('vista'); });
      return;
    }
    if (!occhio) {
      occhio = new IntersectionObserver(function (voci) {
        voci.forEach(function (v) {
          if (v.isIntersecting) { v.target.classList.add('vista'); occhio.unobserve(v.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -60px 0px' });
    }
    pezzi.forEach(function (e) { if (!e.classList.contains('vista')) occhio.observe(e); });
  }

  /* ---- 3. l'elenco che scorre con il riquadro acceso ---- */
  var elenchi = [];
  function montaElenco(scena) {
    var lista = scena.querySelector('.scorrevole');
    if (!lista) return;
    var didascalia = scena.querySelector('.didascalia');
    var griglia = scena.querySelector('.quadri');
    var voci = [].slice.call(lista.children);
    var quadri = griglia ? [].slice.call(griglia.children) : [];
    var n = voci.length;
    if (!n) return;

    /* le tendine: una per voce, ma solo quelle che hanno del contenuto dentro */
    var tendine = [];
    [].slice.call(scena.querySelectorAll('.tendina')).forEach(function (t) {
      tendine[parseInt(t.getAttribute('data-tendina'), 10)] = t;
    });
    var velo = scena.querySelector('.appvelo');

    var o = { scena: scena, lista: lista, voci: voci, quadri: quadri, n: n,
              didascalia: didascalia, tendine: tendine, attesa: 0,
              centri: [], fuoco: 0, acceso: -1 };

    /* chiude quella aperta, poi fa scendere la nuova: una alla volta */
    o.tendi = function (a) {
      if (o.attesa) { clearTimeout(o.attesa); o.attesa = 0; }
      var chiusa = false;
      tendine.forEach(function (t, i) {
        if (t && i !== a && t.classList.contains('giu')) {
          t.classList.remove('giu');
          t.setAttribute('aria-hidden', 'true');
          chiusa = true;
        }
      });
      var nuova = tendine[a];
      if (!nuova) { if (velo) velo.classList.remove('giu'); return; }
      if (velo) velo.classList.add('giu');
      var apri = function () {
        o.attesa = 0;
        if (o.acceso !== a) return;
        nuova.classList.add('giu');
        nuova.setAttribute('aria-hidden', 'false');
      };
      if (chiusa) { o.attesa = setTimeout(apri, 330); } else { apri(); }
    };

    o.misura = function () {
      var f = lista.parentNode;
      o.fuoco = f.clientHeight * 0.42;
      o.centri = voci.map(function (v) { return v.offsetTop + v.offsetHeight / 2; });
      o.muovi();
    };
    o.muovi = function () {
      var alto = scena.offsetHeight - window.innerHeight;
      var p = alto > 0 ? (-scena.getBoundingClientRect().top) / alto : 0;
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      var f = p * (n - 1), i = Math.floor(f);
      if (i > n - 2) i = n - 2; if (i < 0) i = 0;
      var t = n > 1 ? f - i : 0;
      var y = o.centri.length ? o.centri[i] + ((o.centri[i + 1] || o.centri[i]) - o.centri[i]) * t : 0;
      lista.style.transform = 'translate3d(0,' + (o.fuoco - y).toFixed(1) + 'px,0)';
      var a = Math.round(f); if (a < 0) a = 0; if (a > n - 1) a = n - 1;
      if (a !== o.acceso) {
        if (o.acceso > -1) {
          voci[o.acceso].classList.remove('attiva');
          if (quadri[o.acceso]) quadri[o.acceso].classList.remove('attiva');
        }
        voci[a].classList.add('attiva');
        if (quadri[a]) quadri[a].classList.add('attiva');
        if (didascalia) didascalia.textContent = voci[a].getAttribute('data-didascalia') || '';
        o.acceso = a;
        o.tendi(a);
      }
    };
    elenchi.push(o);
    o.misura();
    setTimeout(o.misura, 400);
  }

  /* ---- 4. il muro di foto a colonne, con velocita' diverse ---- */
  var onde = [];
  function montaOnda(scatola) {
    var sezione = scatola.closest ? scatola.closest('.onda') : null;
    /* prima le foto del muro, poi quelle del serbatoio: e' l'ordine del documento,
       e il mazzo e' mescolato con un seme fisso, quindi l'ordine conta. */
    var sorgenti = [].slice.call(document.querySelectorAll('.muro img'));
    if (sezione) {
      sorgenti = sorgenti.concat([].slice.call(sezione.querySelectorAll('.serbatoio img')));
    } else {
      sorgenti = sorgenti.concat([].slice.call(document.querySelectorAll('.serbatoio img')));
    }
    var viste = {}, foto = [];
    sorgenti.forEach(function (i) {
      var s = i.getAttribute('src');
      if (s && !viste[s]) { viste[s] = 1; foto.push(s); }
    });
    if (!foto.length) return;

    var o = { scatola: scatola, foto: foto, colonne: [], quante: 0, mazzo: [], seme: 97 };

    o.quanteColonne = function () {
      var l = window.innerWidth;
      return l >= 1280 ? 8 : l >= 1000 ? 7 : l >= 760 ? 5 : l >= 520 ? 4 : 3;
    };
    /* mazzo mescolato: ogni foto esce una volta per giro, cosi' non si ripetono vicine */
    o.pesca = function () {
      if (!o.mazzo.length) {
        o.mazzo = o.foto.slice();
        for (var i = o.mazzo.length - 1; i > 0; i--) {
          o.seme = (o.seme * 1103515245 + 12345) % 2147483647;
          var j = o.seme % (i + 1), t = o.mazzo[i];
          o.mazzo[i] = o.mazzo[j]; o.mazzo[j] = t;
        }
      }
      return o.mazzo.pop();
    };
    o.costruisci = function (nc) {
      scatola.innerHTML = ''; o.colonne = [];
      var perCol = 8;
      for (var c = 0; c < nc; c++) {
        var col = document.createElement('div'); col.className = 'colonna';
        for (var r = 0; r < perCol; r++) {
          var fig = document.createElement('figure');
          var im = document.createElement('img');
          im.alt = ''; im.loading = 'lazy'; im.onload = o.rimisura; im.src = o.pesca();
          fig.appendChild(im); col.appendChild(fig);
        }
        scatola.appendChild(col); o.colonne.push(col);
      }
      o.quante = nc;
    };
    var attesaM;
    o.rimisura = function () { clearTimeout(attesaM); attesaM = setTimeout(o.misura, 90); };
    o.misura = function () {
      var nc = o.quanteColonne();
      if (nc !== o.quante) o.costruisci(nc);
      var h = scatola.clientHeight, c = (o.quante - 1) / 2;
      o.colonne.forEach(function (col, i) {
        var avanzo = col.scrollHeight - h;                 /* quanto c'e' da far scorrere */
        if (avanzo < 60) avanzo = 60;
        var lontano = c > 0 ? Math.abs(i - c) / c : 0;      /* 0 al centro, 1 ai bordi */
        var veloce = 1 + 0.17 * lontano;                    /* i bordi corrono un po' di piu' */
        var corsa = Math.min(avanzo * 0.62, 330) * veloce;
        var inizio = avanzo * (0.30 - 0.16 * lontano);      /* sfalsatura ad arco */
        if (inizio + corsa > avanzo) corsa = avanzo - inizio;
        if (corsa < 0) corsa = 0;
        col._i = inizio; col._c = corsa;
      });
      o.muovi();
    };
    o.muovi = function () {
      var r = scatola.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < -200 || r.top > vh + 200) return;
      var p = (vh - r.top) / (vh + r.height); p = p < 0 ? 0 : p > 1 ? 1 : p;
      o.colonne.forEach(function (col) {
        col.style.transform = 'translate3d(0,' + (-(col._i + col._c * p)).toFixed(1) + 'px,0)';
      });
    };
    onde.push(o);
    o.misura();
    setTimeout(o.misura, 500);
    setTimeout(o.misura, 1500);
  }

  /* ---- miniature della pagina prodotto: cambiano la foto grande ---- */
  function montaMiniature(dove) {
    [].slice.call((dove || document).querySelectorAll('.prodotto .minia')).forEach(function (g) {
      if (g._montata) return;
      g._montata = true;
      g.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('button[data-grande]') : null;
        if (!b) return;
        var grande = document.getElementById(b.getAttribute('data-vetrina'));
        if (!grande) return;
        grande.src = b.getAttribute('data-grande');
        grande.removeAttribute('srcset');
        [].slice.call(g.querySelectorAll('button')).forEach(function (x) {
          x.removeAttribute('aria-current');
        });
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---- la guida che si sfoglia da sola ---- */
  var piano = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function montaSfoglia(dove) {
    [].slice.call((dove || document).querySelectorAll('.sfoglia')).forEach(function (s) {
      if (s._montata) return;
      s._montata = true;

      var rullo = s.querySelector('.rullo');
      if (!rullo) return;
      var pagine = [].slice.call(rullo.querySelectorAll('.pag'));
      if (pagine.length < 1) return;

      var pallini = s.querySelector('.pallini');
      var nome = s.querySelector('.nome-pag');
      var attesa = (parseFloat(s.getAttribute('data-attesa')) || 4) * 1000;
      var daSola = !s.hasAttribute('data-ferma') && !piano && pagine.length > 1;
      var qui = 0, orologio = null, ripresa = null, inVista = true;

      /* i pallini, uno per pagina */
      var bottoni = [];
      if (pallini && pagine.length > 1) {
        pagine.forEach(function (p, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', (p.getAttribute('data-nome') || ('Pagina ' + (i + 1))));
          b.addEventListener('click', function () { ferma(); vaiA(i, true); });
          pallini.appendChild(b);
          bottoni.push(b);
        });
      }

      function vaiA(i, morbido) {
        qui = (i + pagine.length) % pagine.length;
        var x = qui * rullo.clientWidth;
        if (rullo.scrollTo) {
          rullo.scrollTo({ left: x, behavior: (morbido && !piano) ? 'smooth' : 'auto' });
        } else {
          rullo.scrollLeft = x;
        }
        segna();
      }

      function segna() {
        bottoni.forEach(function (b, i) {
          if (i === qui) { b.setAttribute('aria-current', 'true'); }
          else { b.removeAttribute('aria-current'); }
        });
        if (nome) nome.textContent = pagine[qui].getAttribute('data-nome') || '';
      }

      function avanti() {
        if (!inVista) return;
        vaiA(qui + 1, true);
      }
      function parti() {
        if (!daSola || orologio) return;
        orologio = setInterval(avanti, attesa);
      }
      function ferma() {
        if (orologio) { clearInterval(orologio); orologio = null; }
        clearTimeout(ripresa);
        if (daSola) ripresa = setTimeout(parti, Math.max(attesa, 5000));
      }

      /* chi tocca comanda: l'automatico si fa da parte */
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (e) {
        rullo.addEventListener(e, ferma, { passive: true });
      });
      s.addEventListener('mouseenter', function () {
        if (orologio) { clearInterval(orologio); orologio = null; }
      });
      s.addEventListener('mouseleave', function () { parti(); });

      /* il pallino segue il dito */
      var inCodaS = false;
      rullo.addEventListener('scroll', function () {
        if (inCodaS) return;
        inCodaS = true;
        requestAnimationFrame(function () {
          inCodaS = false;
          var largo = rullo.clientWidth || 1;
          var i = Math.round(rullo.scrollLeft / largo);
          if (i !== qui && i >= 0 && i < pagine.length) { qui = i; segna(); }
        });
      }, { passive: true });

      /* fuori dallo schermo non gira a vuoto */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (voci) {
          voci.forEach(function (v) {
            inVista = v.isIntersecting;
            if (inVista) { parti(); } else if (orologio) { clearInterval(orologio); orologio = null; }
          });
        }, { threshold: .25 }).observe(s);
      } else {
        parti();
      }

      s._vaiA = vaiA;
      s._ferma = ferma;
      segna();
      window.addEventListener('resize', function () { vaiA(qui, false); });
    });
  }

  /* ---- il filo che tiene insieme tutto ---- */
  function monta(dove) {
    barra();
    comparsa(dove);
    montaMiniature(dove);
    montaSfoglia(dove);
    [].slice.call((dove || document).querySelectorAll('.scena')).forEach(function (s) {
      if (!s._montata) { s._montata = true; montaElenco(s); }
    });
    [].slice.call((dove || document).querySelectorAll('.muroscorre')).forEach(function (m) {
      if (!m._montata) { m._montata = true; montaOnda(m); }
    });
  }
  function muoviTutto() {
    elenchi.forEach(function (o) { o.muovi(); });
    onde.forEach(function (o) { o.muovi(); });
  }
  function misuraTutto() {
    elenchi.forEach(function (o) { o.misura(); });
    onde.forEach(function (o) { o.misura(); });
  }

  var inCoda = false;
  window.addEventListener('scroll', function () {
    if (inCoda) return; inCoda = true;
    requestAnimationFrame(function () { inCoda = false; muoviTutto(); });
  }, { passive: true });

  var attesa;
  window.addEventListener('resize', function () {
    clearTimeout(attesa); attesa = setTimeout(misuraTutto, 150);
  });
  window.addEventListener('load', misuraTutto);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { monta(document); });
  } else {
    monta(document);
  }

  /* dentro Personalizza, Shopify ricarica una sezione alla volta */
  document.addEventListener('shopify:section:load', function (e) {
    var d = e.target;
    [].slice.call(d.querySelectorAll('.su')).forEach(function (x) { x.classList.add('vista'); });
    monta(d);
    setTimeout(misuraTutto, 120);
  });
  document.addEventListener('shopify:section:unload', function () {
    elenchi = elenchi.filter(function (o) { return document.body.contains(o.scena); });
    onde = onde.filter(function (o) { return document.body.contains(o.scatola); });
  });
  document.addEventListener('shopify:section:select', function () { setTimeout(misuraTutto, 120); });
  document.addEventListener('shopify:block:select', function (e) {
    [].slice.call(document.querySelectorAll('.su')).forEach(function (x) { x.classList.add('vista'); });
    if (e.target && e.target.closest && e.target.closest('.scena')) setTimeout(misuraTutto, 60);
    var p = e.target && e.target.closest ? e.target.closest('.pag') : null;
    if (p) {
      var sf = p.closest('.sfoglia');
      if (sf && sf._vaiA) {
        sf._ferma();
        sf._vaiA([].slice.call(sf.querySelectorAll('.pag')).indexOf(p), true);
      }
    }
  });
})();
